import { render, staticRenderFns } from "./OrderManagementTableList.vue?vue&type=template&id=6d5f0ebb&scoped=true"
import script from "./OrderManagementTableList.vue?vue&type=script&lang=ts"
export * from "./OrderManagementTableList.vue?vue&type=script&lang=ts"
import style0 from "./OrderManagementTableList.vue?vue&type=style&index=0&id=6d5f0ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f0ebb",
  null
  
)

export default component.exports